import { useEffect } from 'react';
import { useSecurity } from '@dfl/react-security';
import { ANALYTICS_PERMISSIONS } from 'modules/analytics/common/constants';
import { useLocation } from 'react-router';

export const usePostLoginRedirect = (user: any) => {
  const { hasPermission } = useSecurity();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if user just logged in
    const justLoggedIn = sessionStorage.getItem('justLoggedIn');
    if (user && justLoggedIn === 'true' && location.pathname === '/') {
      // Clear the flag
      sessionStorage.removeItem('justLoggedIn');

      // Don't redirect if user is admin
      const isAdmin = hasPermission('ADMIN');
      if (isAdmin) {
        return;
      }

      // Check permissions and redirect for non-admin users
      const hasBiensecAnalytics = hasPermission(ANALYTICS_PERMISSIONS.BIENSEC_AUDIT);
      const hasAuditAnalytics = hasPermission(ANALYTICS_PERMISSIONS.AUDIT);
      const hasSurveyAnalytics = hasPermission(ANALYTICS_PERMISSIONS.SURVEY);

      if (hasBiensecAnalytics) {
        window.location.href = '/analytics/biensec/?&updatedAt=THIS-YEAR';
        return;
      }
      if (hasAuditAnalytics) {
        window.location.href = '/analytics/audits/?&updatedAt=THIS-YEAR';
        return;
      }
      if (hasSurveyAnalytics) {
        window.location.href = '/analytics/survey/?&updatedAt=THIS-YEAR';
      }
    }
  }, [user, location.pathname, hasPermission]);
};
